const module = 'product'
const list = [
  {
    label: 'Product Parent Group',
    url: `/${module}/parent-group`,
    icon: 'apartment',
    code: 'estimation.{}_productparentgroup',
  },
  {
    label: 'Product Group',
    url: `/${module}/group`,
    icon: 'qrcode',
    code: 'estimation.{}_productgroup',
  },
  {
    label: 'Product',
    url: `/${module}/product`,
    icon: 'credit-card',
    code: 'estimation.{}_product',
  },
]

export default { key: module, list }
